export enum GraphLegendPosition {
  top = 'top',
  bottom = 'bottom',
  right = 'right',
  left = 'left',
}

export enum GraphLegendHorizontalAlignment {
  left = 'left',
  center = 'center',
  right = 'right',
}
